import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import type { DeliveryHistoryRow, FailedDistributionRow } from '../types/domain';

/**
 * A customer's whole delivery history (P19) — generalises P14(f)'s per-ticket
 * proof. Both `customerId` and `companyCode` are required by the endpoint;
 * the query stays disabled without both, same reason the endpoint refuses a
 * partial key: DRA master data cannot identify a customer any other way.
 */
export function useDeliveryHistory(customerId: string | null | undefined, companyCode: string | null | undefined) {
  return useQuery({
    queryKey: ['reports', 'delivery-history', customerId, companyCode],
    queryFn: () => api.get<DeliveryHistoryRow[]>(
      `/api/v1/reports/delivery-history?customerId=${encodeURIComponent(customerId!)}&companyCode=${encodeURIComponent(companyCode!)}`,
    ),
    enabled: !!customerId && !!companyCode,
  });
}

/** Every send the pipeline did not complete (P19, Marcello's report 4). */
export function useFailedDistributions() {
  return useQuery({
    queryKey: ['reports', 'failed-distributions'],
    queryFn: () => api.get<FailedDistributionRow[]>('/api/v1/reports/failed-distributions'),
  });
}
